import createIcon from '../../createIcon';

/**
 * @component @name Bed
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTAuNzhWOEMyMSA2LjM1IDE5LjY1IDUgMTggNUgxNEMxMy4yMyA1IDEyLjUzIDUuMyAxMiA1Ljc4QzExLjQ3IDUuMyAxMC43NyA1IDEwIDVINkM0LjM1IDUgMyA2LjM1IDMgOFYxMC43OEMyLjM5IDExLjMzIDIgMTIuMTIgMiAxM1YxOUg0VjE3SDIwVjE5SDIyVjEzQzIyIDEyLjEyIDIxLjYxIDExLjMzIDIxIDEwLjc4Wk0xNCA3SDE4QzE4LjU1IDcgMTkgNy40NSAxOSA4VjEwSDEzVjhDMTMgNy40NSAxMy40NSA3IDE0IDdaTTUgOEM1IDcuNDUgNS40NSA3IDYgN0gxMEMxMC41NSA3IDExIDcuNDUgMTEgOFYxMEg1VjhaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Bed = createIcon('Bed', [
  [
    'path',
    {
      d: 'M21 10.78V8C21 6.35 19.65 5 18 5H14C13.23 5 12.53 5.3 12 5.78C11.47 5.3 10.77 5 10 5H6C4.35 5 3 6.35 3 8V10.78C2.39 11.33 2 12.12 2 13V19H4V17H20V19H22V13C22 12.12 21.61 11.33 21 10.78ZM14 7H18C18.55 7 19 7.45 19 8V10H13V8C13 7.45 13.45 7 14 7ZM5 8C5 7.45 5.45 7 6 7H10C10.55 7 11 7.45 11 8V10H5V8Z',
      key: '1g06ob',
    },
  ],
]);

export default Bed;
